import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withKeys as _withKeys, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-660507cb")

_pushScopeId("data-v-660507cb")
const _hoisted_1 = { class: "flex flex--width flex--v flex--valign-c flex--gap-50" }
const _hoisted_2 = { class: "flex flex--width flex--v flex--valign-c flex--gap-30" }
const _hoisted_3 = {
  class: "pagination-new flex--width flex flex--halign-c",
  "aria-label": "Jahresnavigation"
}
const _hoisted_4 = { class: "pagination-new-nav flex flex--valign-c flex--gap-30" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "pagination-button-text pagination-button-text--arrow text text--accent-gray-a text--size-40 text--bold" }, /*#__PURE__*/_toDisplayString("<"), -1)
const _hoisted_6 = { class: "pagination-buttons-inner flex flex--valign-c flex--gap-0" }
const _hoisted_7 = { class: "pagination-button-text text text--primary-b text--size-22 text--medium" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "pagination-button-text pagination-button-text--arrow text text--accent-gray-a text--size-40 text--bold" }, /*#__PURE__*/_toDisplayString(">"), -1)
const _hoisted_9 = { class: "pagination-header-buttons flex flex--halign-sb pe-none" }
const _hoisted_10 = { class: "flex--width d-grid cal-layout gap-3 align-items-start" }
const _hoisted_11 = { class: "flex flex--width flex--v flex--valign-c flex--gap-30" }
const _hoisted_12 = { class: "flex--width text text-uppercase text--primary-b text--size-20 text--bold" }
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "bi bi-calendar-event" }, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "panel-muted panel-muted--empty text text--accent-gray-b text--size-16 text--medium text-center"
}
const _hoisted_15 = {
  key: 1,
  class: "pb-3 flex flex--width flex--v flex--valign-c flex--gap-10"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "event-dot mt-1 flex-shrink-0 rounded-circle dot-event" }, null, -1)
const _hoisted_17 = { class: "flex flex--v flex--gap-8 flex--valign-s" }
const _hoisted_18 = { class: "panel-muted text text--accent-gray-b text--size-16 text--medium" }
const _hoisted_19 = { class: "panel-name-text text text--primary-a text--size-18 text--semi-bold" }
const _hoisted_20 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_21 = { class: "row row-cols-1 row-cols-md-2 row-cols-lg-3 g-2" }
const _hoisted_22 = { class: "p-2" }
const _hoisted_23 = { class: "mb-1 month-name-text text text--size-18 text--medium flex flex--valign-c flex--gap-5" }
const _hoisted_24 = {
  key: 0,
  class: "month-event-badge fs-6 ms-2 flex-shrink-0 text text--bold text--size-24"
}
const _hoisted_25 = { class: "day-grid" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_GenericButton = _resolveComponent("GenericButton")
  const _component_Plane = _resolveComponent("Plane")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("nav", _hoisted_4, [
          _createVNode("button", {
            class: "pagination-button",
            "aria-label": "Vorheriges Jahr",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change-year', _ctx.year - 1)))
          }, [
            _hoisted_5
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("span", _hoisted_7, _toDisplayString(_ctx.year), 1)
          ]),
          _createVNode("button", {
            class: "pagination-button",
            "aria-label": "Nächstes Jahr",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('change-year', _ctx.year + 1)))
          }, [
            _hoisted_8
          ])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_GenericButton, {
            class: "pagination-header-button position-absolute start-0",
            title: _ctx.$trans('auth.login_school'),
            secondary: true,
            circular: true,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clickLoginSchool()))
          }, null, 8, ["title"]),
          _createVNode(_component_GenericButton, {
            class: "pagination-header-button position-absolute end-0",
            title: _ctx.$trans('event.jump_to_today'),
            circular: true,
            style: { visibility: _ctx.isCurrentYear ? 'hidden' : 'visible' },
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('change-year', new Date().getFullYear())))
          }, null, 8, ["title", "style"])
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode(_component_Plane, {
          class: "panel-bg",
          darker: true
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _hoisted_13,
                _createTextVNode(" " + _toDisplayString(_ctx.selectedMonthName), 1)
              ]),
              (_ctx.panelEvents.length === 0)
                ? (_openBlock(), _createBlock("span", _hoisted_14, _toDisplayString(_ctx.$trans("event.no_events")), 1))
                : (_openBlock(), _createBlock("div", _hoisted_15, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.panelEvents, (ev, i) => {
                      return (_openBlock(), _createBlock("div", {
                        key: i,
                        class: ["flex flex--gap-10", { 'border-top panel-divider': i > 0 }]
                      }, [
                        _hoisted_16,
                        _createVNode("div", _hoisted_17, [
                          _createVNode("span", _hoisted_18, [
                            _createTextVNode(_toDisplayString(ev.weekday) + ", " + _toDisplayString(ev.day) + ". " + _toDisplayString(_ctx.selectedMonthName) + " ", 1),
                            (ev.isMultiDay)
                              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode("– " + _toDisplayString(ev.endWeekday) + ", " + _toDisplayString(ev.endDay) + ". " + _toDisplayString(ev.endMonth), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("span", _hoisted_19, [
                            _createTextVNode(_toDisplayString(ev.name) + " ", 1),
                            _hoisted_20,
                            _createTextVNode(" " + _toDisplayString(ev.organizer_name), 1)
                          ])
                        ])
                      ], 2))
                    }), 128))
                  ]))
            ])
          ]),
          _: 1
        }),
        _createVNode("div", _hoisted_21, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.months, (month, m) => {
            return (_openBlock(), _createBlock("div", {
              key: m,
              class: "col"
            }, [
              _createVNode(_component_Plane, {
                class: ["h-100 month-card", {
                                'month-selected': _ctx.selectedMonth === m,
                                'month-current': m === _ctx.currentMonth && _ctx.selectedMonth !== m,
                            }],
                role: "button",
                tabindex: "0",
                onClick: ($event: any) => (_ctx.selectMonth(m)),
                onKeydown: [
                  _withKeys(($event: any) => (_ctx.selectMonth(m)), ["enter"]),
                  _withKeys(_withModifiers(($event: any) => (_ctx.selectMonth(m)), ["prevent"]), ["space"])
                ]
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_22, [
                    _createVNode("div", _hoisted_23, [
                      _createTextVNode(_toDisplayString(month) + " ", 1),
                      (_ctx.hasEventInMonth(m))
                        ? (_openBlock(), _createBlock("span", _hoisted_24, _toDisplayString(_ctx.countEventsInMonth(m)), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_25, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dayHeaders, (day, i) => {
                        return (_openBlock(), _createBlock("div", {
                          key: 'h' + i,
                          class: ["dc text text--size-18 flex flex--valign-c flex--gap-10 justify-content-center text-day-header dc-header", i >= 5 ? 'text-weekend' : '']
                        }, _toDisplayString(day), 3))
                      }), 128)),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getStartOffset(m), (n) => {
                        return (_openBlock(), _createBlock("div", {
                          key: 'e' + n,
                          class: "dc"
                        }))
                      }), 128)),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getDaysInMonth(m), (d) => {
                        return (_openBlock(), _createBlock("div", {
                          key: d,
                          class: ["dc dc-day text text--size-16 flex flex--valign-c flex--gap-10 justify-content-center", _ctx.getDayClass(m, d)]
                        }, _toDisplayString(d), 3))
                      }), 128))
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["class", "onClick", "onKeydown"])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
})